<template>
  <v-row no-gutters class="align-baseline">
    <v-col cols="auto">
      <slot name="prependIcon" v-bind="$props">
        <v-icon :color="disabled ? 'disabled' : 'success'" class="pr-1">
          mdi-check
        </v-icon>
      </slot>
    </v-col>
    <v-col cols="auto" class="pr-1">
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="pr-1 text-body-2" :class="{ 'text--disabled': disabled }">
            {{ file }}
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="auto">
          <italic-subheader
            :disabled="disabled"
            translation-path="admin.addDate"
            :params="{ date: dateFormatted }"
          ></italic-subheader>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="auto">
      <dots-menu :items="dotsMenuItems" v-on="$listeners" :disabled="disabled"></dots-menu>
    </v-col>
  </v-row>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'AddedFileInfo',
  components: {
    DotsMenu,
    ItalicSubheader,
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    file: {
      type: String,
      required: true,
    },
    dotsMenuItems: {
      type: Array,
      default: () => [
        {
          name: 'delete',
        },
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dateFormatted() {
      return this.$dayjs(this.date).format('L');
    },
  },
};
</script>

<style lang="scss" scoped></style>
